import {HoistModel, managed} from '@xh/hoist/core';
import {ItemDetailsModel} from './impl/ItemDetailsModel';
import {AccountStructureModel} from './impl/AccountStructureModel';

export class AccountStructureTabModel extends HoistModel {
    @managed graphModel = new AccountStructureModel();
    @managed detailsModel = new ItemDetailsModel();

    constructor() {
        super();

        this.addReaction({
            track: () => this.graphModel.selectedItem,
            run: item => (item ? this.detailsModel.openAsync(item) : this.detailsModel.clear())
        });
    }
}
